import { Loader } from "@launchmetrics/lm-ui";
import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

function RecoveryFormSearch(props) {
	const { paginatedSearchLoading, onSubmit, type, onChange, loading} = props;
	const [currentType, setCurrentType] = useState(type || '');

	const onChangeForm = (ev) => {
		setCurrentType(ev.target.value);
	}

	const onSubmitClick = (ev) => {
		ev.preventDefault();
		onChange(currentType);
		onSubmit();
	};

	const showLoader = () => {
		if (loading || paginatedSearchLoading) {
			return <Loader styleProps={{ marginLeft: '10px'}}size={20} />;
		}
	}

	return (
		<Form>
			<Row className="align-items-center">
				<Col xs="auto">
					<Form.Control className="custom-select" as="select" onChange={onChangeForm} value={currentType}>
						<option value="">Choose provider</option>
						<option value="instagram">Instagram</option>
						<option value="youtube">Youtube</option>
						<option value="facebook">Facebook</option>
						<option value="twitter">Twiter</option>
						<option value="weibo">Weibo</option>
						<option value="wechat_public">Wechat</option>
						<option value="douyin">Douyin</option>
						<option value="bilibili">Bilibili</option>
					</Form.Control>
				</Col>
				<Col xs="auto">
					<Button
						type="submit"
						className="mr-1 mb-1"
						onClick={onSubmitClick}
						disabled={loading || paginatedSearchLoading || !currentType}
					>
						Submit
						{showLoader()}
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default RecoveryFormSearch;
